var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-card",
        {
          staticClass: "cardClassDetailForm no-margin",
          attrs: { title: "LBL0000519" },
        },
        [
          _c(
            "template",
            { slot: "card-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable
                    ? _c("c-btn", {
                        attrs: { label: "LBLSELECT", icon: "check" },
                        on: { btnClicked: _vm.select },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("template", { slot: "card-detail" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("q-tree", {
                  ref: "dept-multi",
                  attrs: {
                    nodes: _vm.deptTree,
                    "tick-strategy": "strict",
                    "node-key": "deptCd",
                    "label-key": "deptName",
                    "children-key": "children",
                    "no-nodes-label": _vm.$comm.getLangLabel("LBL0000513"),
                    "default-expand-all": true,
                    ticked: _vm.checkDepts,
                  },
                  on: {
                    "update:ticked": function ($event) {
                      _vm.checkDepts = $event
                    },
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }